import React from 'react';
import { C } from '../../../components/UI';
import { MarketplaceAppCatalogDto } from '../../../services/api';

export default function AppCard({ app, onClick }: { app: MarketplaceAppCatalogDto; onClick: () => void }) {
    return (
        <div
            onClick={onClick}
            style={{
                background: C.card, border: `1px solid ${C.border}`, borderRadius: 12,
                padding: 18, cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 10,
                transition: 'box-shadow 0.15s, transform 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                    width: 44, height: 44, borderRadius: 10, overflow: 'hidden', flexShrink: 0,
                    background: C.bg, border: `1px solid ${C.border}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    {app.logoUrl
                        ? <img src={app.logoUrl} alt={app.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        : <span style={{ fontSize: 18, fontWeight: 700, color: C.textMuted }}>{app.name.charAt(0)}</span>}
                </div>
                <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 14.5, color: C.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{app.name}</div>
                    <div style={{ fontSize: 11.5, color: C.textMuted }}>{app.category}</div>
                </div>
            </div>
            <div style={{ fontSize: 13, color: C.textSub, lineHeight: 1.4, flex: 1 }}>{app.shortDescription}</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{
                    fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 20,
                    background: app.pricingModel === 'Free' ? C.greenBg : C.purpleBg,
                    color: app.pricingModel === 'Free' ? C.green : C.purple,
                }}>
                    {app.pricingModel === 'Free' ? 'Free' : `$${app.monthlyPrice}/mo`}
                </span>
                {app.isFeatured && <span style={{ fontSize: 11, fontWeight: 600, color: C.yellow }}>★ Featured</span>}
            </div>
        </div>
    );
}
